<template>
    <common-summary>
        <common-summary-item :label="$t('pages.referrals.show.details.patient_name')">
            <common-content-spacer height="tiny">
                <common-user-name :user="referral.patient"></common-user-name>

                <template v-if="referral.patient.mobilePhone">
                    <common-icon-info icon="phone" size="medium">
                        {{ referral.patient.mobilePhone }}
                    </common-icon-info>
                    <common-summary-item
                        :label="$t('pages.referrals.show.details.date_of_birth')"
                        :isInline="true"
                        :isCompact="true"
                        width="full"
                    >
                        {{ patientBirthDate }}
                    </common-summary-item>
                </template>
            </common-content-spacer>
        </common-summary-item>

        <common-summary-item>
            <referrals-datetime :referral="referral"></referrals-datetime>
        </common-summary-item>

        <common-summary-item
            :label="$t('pages.referrals.show.details.diagnosis')"
            :isInline="true"
            :isCompact="true"
            width="full"
        >
            {{ referral.diagnosis }}
        </common-summary-item>

        <common-summary-item
            :label="$t('pages.referrals.show.details.insurance')"
            :isInline="true"
            :isCompact="true"
            width="full"
        >
            {{ referral.insurancePlan.name }}
        </common-summary-item>

        <common-summary-item
            v-if="referral.insuranceNumber"
            :label="$t('pages.referrals.show.details.insurance_number')"
            :isInline="true"
            :isCompact="true"
            width="full"
        >
            {{ referral.insuranceNumber }}
        </common-summary-item>

        <common-summary-item
            v-if="referral.insuranceGroupNumber"
            :label="$t('pages.referrals.show.details.insurance_group_number')"
            :isInline="true"
            :isCompact="true"
            width="full"
        >
            {{ referral.insuranceGroupNumber }}
        </common-summary-item>

        <common-summary-item
            :label="$t('pages.referrals.show.details.insurance_authorization_status')"
            :isInline="true"
            :isCompact="true"
            width="full"
        >
            {{
                referral.isInsuranceAuthorizationRequired
                    ? $t('pages.referrals.show.details.insurance_authorization_statuses.required')
                    : $t('pages.referrals.show.details.insurance_authorization_statuses.not_required')
            }}
        </common-summary-item>

        <common-summary-item
            v-if="referral.facilityServiceTests && referral.facilityServiceTests.length"
            :label="$t('pages.referrals.show.details.tests')"
            :isInline="true"
            :isCompact="true"
            width="full"
        >
            <common-badges-list :listElements="referral.facilityServiceTests.map((item) => item.name)"></common-badges-list>
        </common-summary-item>

        <common-summary-item
            v-if="referral.referralNotes && referral.referralNotes.length"
            :label="$t('pages.referrals.show.details.attachments_notes', { n: referral.referralNotes.length })"
            :isInline="false"
            :isCompact="false"
            width="full"
        >
            <common-images ref="images" :images="referral.referralNotes" :showMoreOption="true"></common-images>
        </common-summary-item>

        <common-summary-item
            v-if="referral.consultationReports && referral.consultationReports.length"
            :label="$t('pages.referrals.show.details.attachments_consultation', { n: referral.consultationReports.length })"
            :isInline="false"
            :isCompact="false"
            width="full"
        >
            <common-images ref="images" :images="referral.consultationReports" :showMoreOption="true"></common-images>
        </common-summary-item>

        <common-summary-item
            v-if="referral.attachments && referral.attachments.length"
            :label="$t('pages.referrals.show.details.attachments_message', { n: referral.attachments.length })"
            :isInline="false"
            :isCompact="false"
            width="full"
        >
            <common-images ref="images" :images="referral.attachments" :showMoreOption="true"></common-images>
        </common-summary-item>
    </common-summary>
</template>

<script>
    import ReferralsDatetime from 'components/page-elements/ReferralsDatetime'
    import dayjs from 'dayjs'

    export default {
        components: {
            ReferralsDatetime,
        },

        props: {
            referral: { type: Object, required: true },
        },

        computed: {
            patientBirthDate() {
                return dayjs(this.referral.patient.dateOfBirth).format('MM/DD/YYYY')
            },
        },
    }
</script>
